import packageInfo from '../package.json';
import moment from 'moment';
import platform from 'platform';

export const AuditEventAction = {
  TOKEN_ENTERED: {
    action: 'TOKEN_ENTERED',
    category: 'USER_IDENTIFIERS',
  },
  CHECKIN_START: {
    action: 'CHECKIN_START',
    category: 'CHECK IN',
  },
  CHECKIN_END: {
    action: 'CHECKIN_END',
    category: 'CHECK IN',
  },
  LAUNCH_RESOURCE: {
    action: 'LAUNCH_RESOURCE',
    category: 'RESOURCES',
  },
  EXPAND_RESOURCE: {
    action: 'EXPAND_RESOURCE',
    category: 'RESOURCES',
  },
  FAV_RESOURCE: {
    action: 'FAV_RESOURCE',
    category: 'RESOURCES',
  },
  COMPLETE_RESOURCE: {
    action: 'COMPLETE_RESOURCE',
    category: 'RESOURCES',
  },
  KHP_FOOTER: {
    action: 'FOOTER',
    category: 'KHP_FOOTER',
  },
  WTC_FOOTER: {
    action: 'FOOTER',
    category: 'WTC_FOOTER',
  },
  HFW_FOOTER: {
    action: 'FOOTER',
    category: 'HFW_FOOTER',
  },
  TC_FOOTER: {
    action: 'FOOTER',
    category: 'TC_FOOTER',
  },
  RESULT_FILTERS: {
    action: 'RESULT_VISIBILITY',
    category: 'RESULT_FILTERS',
  },
  RESULT_GRAPH: {
    action: 'GRAPH_TYPE',
    category: 'RESULT_GRAPH',
  },
};

export function createClientAnalytics(category, action, actionParam) {
  return {
    action: action,
    actionParameters: actionParam,
    category: category,
    appName: packageInfo.name,
    appVersion: packageInfo.version,
    clientCreated: moment(moment(), moment.ISO_8601).toISOString(),
    clientDeviceIdentifier: 'N/A',
    clientDeviceModel: 'N/A',
    clientOsVersion: getClientOsVersion(),
    clientPlatform: 'WEB',
    clientScreenSize: getScreenSize(),
  };
}

function getScreenSize() {
  if (window?.screen?.width) {
    return `${window.screen.width}px`;
  }
  return 'N/A';
}

function getClientOsVersion() {
  let osVersion;
  try {
    osVersion = platform.os.toString();
  } catch (e) {
    osVersion = 'N/A';
  }
  return osVersion;
}
